// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_LimitsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /subaccounts/anticipations/limits/{subaccount_id}
 *
 * Returns the provider anticipation-limits payload as a single typed object:
 *
 *   - supported ← whether the provider exposes anticipation limits.
 *                 true  → provider->supportsAnticipationLimits() and the
 *                         `limits` blob below is populated.
 *                 false → provider has no limits query; `message` explains it
 *                         and `limits` is null (treated as unlimited upstream).
 *   - message   ← human-readable note, set only on the no-limits (false) branch.
 *                 Null on the supported branch.
 *   - limits    ← PaymentProviderInterface::getAnticipationLimits() —
 *                 { creditCard: {total, available}, bankSlip: {total, available} }
 *                 (ASAAS GET /anticipations/limits). Null on the no-limits branch.
 *
 * @see anticipations.php::limits()
 * @see PaymentProviderInterface::getAnticipationLimits()
 */
import type { SubaccountsAnticipations_LimitsLimitsRow } from './SubaccountsAnticipations_LimitsLimitsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_LimitsResponseDados {
supported: boolean
message?: string
limits?: SubaccountsAnticipations_LimitsLimitsRow
}

export type SubaccountsAnticipations_LimitsResponse = ApiResponse<SubaccountsAnticipations_LimitsResponseDados>;

registerResponseContract('SubaccountsAnticipations_LimitsResponse', {
  supported: { type: 'boolean', required: true },
  message:   { type: 'string',  required: false },
  limits: {
    type: 'object',
    required: false,
    fields: {
      creditCard: {
        type: 'object',
        required: false,
        fields: {
          total:     { type: 'number',  required: false },
          available: { type: 'number',  required: false },
        },
      },
      bankSlip: {
        type: 'object',
        required: false,
        fields: {
          total:     { type: 'number',  required: false },
          available: { type: 'number',  required: false },
        },
      },
    },
  },
})
